import { render, staticRenderFns } from "./PresentationsSection.v2.vue?vue&type=template&id=74e8a61c&scoped=true"
import script from "./PresentationsSection.v2.vue?vue&type=script&lang=js"
export * from "./PresentationsSection.v2.vue?vue&type=script&lang=js"
import style0 from "./PresentationsSection.v2.vue?vue&type=style&index=0&id=74e8a61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e8a61c",
  null
  
)

export default component.exports